// src/utils/shiftUtils.ts

export interface ShiftRequest {
  id: string;
  pharmacistId: string;
  requestedWage?: number;
  status?: string;
  [key: string]: any;
}


// Finds a request for a given userId from any object that has a shiftToRequests array.
//  Works safely with ShiftProps, Shift, or other compatible types.

export const findUserShiftRequest = <T extends { shiftToRequests?: any[] }>(
  shift: T,
  userId?: string
): ShiftRequest | null => {
  if (!shift?.shiftToRequests || !Array.isArray(shift.shiftToRequests)) return null;
   if (!userId) return null;
  return shift.shiftToRequests.find(req => req?.pharmacistId === userId) || null;
};


// ----------------------------
// function for ApplicantRequest
// ----------------------------

/**
 * Finds a user's request that matches a given shiftId
 * inside applicant.userToRequests array.
 *
 * @param applicant - The applicant object containing userToRequests.
 * @param shiftId - The shift ID to match.
 * @returns The matching user request object, or null if not found.
 */
export const findApplicantUserRequest = (
  applicant: any,
  shiftId?: string
): ShiftRequest | null => {
  if (!applicant?.userToRequests || !Array.isArray(applicant.userToRequests)) return null;
  if (!shiftId) return null;

  return (
    applicant.userToRequests.find(
      (req: ShiftRequest) => req?.shiftId === shiftId
    ) || null
  );
};